import React, { useEffect, useState, useRef, lazy } from 'react';
type Props = {
  children: React.ReactNode;
  rootMargin?: string;
  minHeight?: number;
  /** Optional fallback rendered before the section is mounted (keeps layout stable). */
  placeholder?: React.ReactNode;
};
/**
 * Mounts its children only when it scrolls near the viewport.
 * Combined with lazy, this defers BOTH chunk download and render
 * for below-the-fold sections, drastically improving TTI/LCP.
 */
export function LazyMount({
  children,
  rootMargin = '600px 0px',
  minHeight = 200,
  placeholder
}: Props) {
  const ref = useRef<HTMLDivElement | null>(null);
  const [shouldRender, setShouldRender] = useState(false);
  useEffect(() => {
    if (shouldRender) return;
    if (typeof IntersectionObserver === 'undefined') {
      setShouldRender(true);
      return;
    }
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          setShouldRender(true);
          io.disconnect();
          break;
        }
      }
    }, {
      rootMargin
    });
    io.observe(el);
    return () => io.disconnect();
  }, [rootMargin, shouldRender]);
  return <div ref={ref} style={shouldRender ? undefined : {
    minHeight
  }} data-id="element-307">
      {shouldRender ? children : placeholder ?? null}
    </div>;
}